import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { GlobalProgressBar } from './components/ui/GlobalProgressBar';
import { router } from './router';
import { initTheme } from './lib/theme';

import './index.css';

// Apply the persisted theme before React mounts so the first paint
// already has the right colors — otherwise dark-mode users get a
// brief flash of light theme on every reload.
initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: false },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element in index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <GlobalProgressBar />
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
